export const tokenExpiresAtStorageKey = 'tokenExpiresAt'
export const tokenTypeStorageKey = 'tokenType'

export const createTokenState = (response, current, now = Date.now()) => {
  const accessToken = response.access_token
  const refreshToken = response.refresh_token || current.refreshToken
  const tokenType = response.token_type || current.tokenType
  const expiresIn = Number(response.expires_in)
  if (!accessToken || !tokenType || !Number.isFinite(expiresIn)) {
    throw new Error('The token endpoint returned an invalid response.')
  }

  return {
    accessToken,
    refreshToken,
    tokenType,
    tokenExpiresAt: now + expiresIn * 1000
  }
}

export const readPersistedTokenState = (auth, storage) => {
  const accessToken = auth.getToken() || null
  const storedExpiry = Number(storage.getItem(tokenExpiresAtStorageKey))
  return {
    accessToken,
    refreshToken: auth.getRefreshToken() || null,
    tokenType: accessToken ? storage.getItem(tokenTypeStorageKey) : null,
    tokenExpiresAt: accessToken && Number.isFinite(storedExpiry) && storedExpiry > 0
      ? storedExpiry
      : null
  }
}

export const persistTokenMetadata = (storage, tokenState) => {
  storage.setItem(tokenExpiresAtStorageKey, tokenState.tokenExpiresAt.toString())
  storage.setItem(tokenTypeStorageKey, tokenState.tokenType)
}

export const clearTokenMetadata = storage => {
  storage.removeItem(tokenExpiresAtStorageKey)
  storage.removeItem(tokenTypeStorageKey)
}



// WEBPACK FOOTER //
// ./src/auth/tokenState.js